const footerLinks = {
  servicos: [
    "Transfer Aeroporto",
    "Executivo Corporativo",
    "Turismo & City Tour",
    "Eventos Especiais",
    "Motorista Particular",
  ],
  empresa: [
    "Sobre Nós",
    "Nossa Frota",
    "Depoimentos",
    "Trabalhe Conosco",
  ],
};

export default function Footer() {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-zinc-950 border-t border-zinc-800">
      {/* CTA Banner */}
      <div className="bg-gradient-to-r from-zinc-700 via-slate-500 to-zinc-700 py-10 px-6">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h3 className="text-white font-bold text-2xl md:text-3xl">Pronto para viajar?</h3>
            <p className="text-white/70 mt-1">Reserve agora e experimente o transporte executivo premium ou corporativo.</p>
          </div>
          <button
            onClick={() => handleNav("#contact")}
            className="flex items-center gap-2 bg-black hover:bg-zinc-900 text-slate-300 font-bold px-8 py-4 rounded-md transition-all duration-300 whitespace-nowrap cursor-pointer flex-shrink-0"
          >
            <i className="ri-car-line"></i>
            Reservar Agora
          </button>
        </div>
      </div>

      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img
              src="https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/fe5c18211bf500b7fcedb51dc1a1fe0b.png"
              alt="Transporte Menezes"
              className="h-14 w-auto object-contain mb-4"
            />
            <p className="text-gray-500 text-sm leading-relaxed mb-6">
              Transporte executivo premium com excelência, discrição e pontualidade. Sua mobilidade em primeiro lugar.
            </p>
            <div className="flex gap-3">
              {[
                { icon: "ri-instagram-line", href: "https://www.instagram.com/transportemenezess" },
                { icon: "ri-whatsapp-line", href: "https://wa.me/5519974056980" },
              ].map((social, idx) => (
                <a
                  key={idx}
                  href={social.href}
                  rel="nofollow noopener noreferrer"
                  className="w-9 h-9 flex items-center justify-center bg-zinc-800 hover:bg-slate-400/20 border border-zinc-700 hover:border-slate-400/50 rounded-md text-gray-400 hover:text-slate-300 transition-all duration-300 cursor-pointer"
                >
                  <i className={`${social.icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-5">Serviços</h4>
            <ul className="flex flex-col gap-3">
              {footerLinks.servicos.map((item, idx) => (
                <li key={idx}>
                  <span className="text-gray-500 text-sm">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-5">Empresa</h4>
            <ul className="flex flex-col gap-3">
              {footerLinks.empresa.map((item, idx) => (
                <li key={idx}>
                  <a
                    href="https://wa.me/5519974056980"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className="text-gray-500 hover:text-slate-300 text-sm transition-colors duration-300 cursor-pointer"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-5">
              <a href="#contact" onClick={(e) => { e.preventDefault(); handleNav("#contact"); }}>Contato</a>
            </h4>
            <div className="flex flex-col gap-4">
              {[
                { icon: "ri-whatsapp-line", text: "(19) 97405-6980" },
                { icon: "ri-mail-line", text: "Transportes.menezes@hotmail.com" },
                { icon: "ri-mail-send-line", text: "transportes.menezes@thnezes.com" },
                { icon: "ri-map-pin-line", text: "Rua Cândido Bueno, 1299 - Sala 12 / Centro — Jaguariúna/SP · Jaguar Center Plaza" },
                { icon: "ri-time-line", text: "Atendimento 24h / 7 dias" },
              ].map((item, idx) => (
                <div key={idx} className="flex items-center gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-slate-400 text-sm`}></i>
                  </div>
                  <span className="text-gray-500 text-sm">{item.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-zinc-800 px-6 py-6">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-3">
          <p className="text-gray-600 text-sm">
            &copy; {new Date().getFullYear()} Transporte Menezes. Todos os direitos reservados.
          </p>
          <p className="text-gray-600 text-sm">
            · Criado por:{" "}
            <a
              href="https://guepardosites.link"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="text-slate-400 hover:text-slate-300 transition-colors cursor-pointer"
            >
              guepardosites.link
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
